import React from 'react'

import type { Poll } from '../model/Poll'

import { PollAnswered } from './PollAnswered'
import { PollItem } from './PollItem'

import './PollsList.scss'

type PollsListProps = {
  polls: Poll[]
  answeredPollIds: Set<number>
}

export const PollsList = ({ polls, answeredPollIds }: PollsListProps) => {
  if (polls.length === 0) {
    return null
  }

  return (
    <div className="polls-list-component">
      {polls.map((poll) =>
        answeredPollIds.has(poll.pollId) && poll.open ? (
          <PollAnswered key={poll.pollId} />
        ) : (
          <PollItem key={poll.pollId} poll={poll} />
        )
      )}
    </div>
  )
}
